var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { observable, makeObservable, action } from 'mobx';
export class BrowserModal {
    parent;
    constructor(parent) {
        this.parent = parent;
        makeObservable(this);
    }
    get browserRuntime() {
        return this.parent;
    }
    get app() {
        return this.browserRuntime.app;
    }
    isBrowserModalOpen = false;
    browserModalLocation = '';
    browserModalTitle = '';
    showLoginModal() {
        this.closeAllModals();
        this.browserModalTitle = 'Login';
        this.browserModalLocation = `/auth/signin?inline=1&time=${new Date().getTime()}`;
        this.isBrowserModalOpen = true;
    }
    showLogoutModal() {
        this.closeAllModals();
        this.browserModalTitle = 'Logout';
        this.browserModalLocation = `/auth/signout?inline=1&time=${new Date().getTime()}`;
        this.isBrowserModalOpen = true;
    }
    showSignupModal() {
        this.closeAllModals();
        this.browserModalTitle = this.app.user.userInfo.isGuestUser ? 'Kostenlos registrieren' : 'Zusätzlichen Account erstellen';
        this.browserModalLocation = `/auth/signup?inline=1&time=${new Date().getTime()}`;
        this.isBrowserModalOpen = true;
    }
    closeAllModals() {
        this.browserRuntime.app.menubarUser.isUserMenuOpen = false;
        this.browserRuntime.app.menubarUser.dialogs.closeAllModals();
    }
}
__decorate([
    observable
], BrowserModal.prototype, "isBrowserModalOpen", void 0);
__decorate([
    observable
], BrowserModal.prototype, "browserModalLocation", void 0);
__decorate([
    observable
], BrowserModal.prototype, "browserModalTitle", void 0);
__decorate([
    action.bound
], BrowserModal.prototype, "showLoginModal", null);
__decorate([
    action.bound
], BrowserModal.prototype, "showLogoutModal", null);
__decorate([
    action.bound
], BrowserModal.prototype, "showSignupModal", null);
__decorate([
    action.bound
], BrowserModal.prototype, "closeAllModals", null);
